import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import ProformaTable from "../../components/Proforma"

const Proformas = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Proformas | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <ProformaTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Proformas
